function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * @module ol/renderer/canvas/ImageLayer
 */
import CanvasLayerRenderer from './Layer.js';
import ImageState from '../../ImageState.js';
import ViewHint from '../../ViewHint.js';
import { apply as applyTransform, compose as composeTransform } from '../../transform.js';
import { containsCoordinate, containsExtent, getHeight, getIntersection, getWidth, intersects as intersectsExtent, isEmpty } from '../../extent.js';
import { fromUserExtent } from '../../proj.js';

/**
 * @classdesc
 * Canvas renderer for image layers.
 * @api
 */
var CanvasImageLayerRenderer = /*#__PURE__*/function (_CanvasLayerRenderer) {
  /**
   * @param {import("../../layer/Image.js").default} imageLayer Image layer.
   */
  function CanvasImageLayerRenderer(imageLayer) {
    var _this;
    _classCallCheck(this, CanvasImageLayerRenderer);
    _this = _callSuper(this, CanvasImageLayerRenderer, [imageLayer]);

    /**
     * @protected
     * @type {?import("../../Image.js").default}
     */
    _this.image_ = null;
    return _this;
  }

  /**
   * @return {import('../../DataTile.js').ImageLike} Image.
   */
  _inherits(CanvasImageLayerRenderer, _CanvasLayerRenderer);
  return _createClass(CanvasImageLayerRenderer, [{
    key: "getImage",
    value: function getImage() {
      return !this.image_ ? null : this.image_.getImage();
    }

    /**
     * Determine whether render should be called.
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */
  }, {
    key: "prepareFrame",
    value: function prepareFrame(frameState) {
      var layerState = frameState.layerStatesArray[frameState.layerIndex];
      var pixelRatio = frameState.pixelRatio;
      var viewState = frameState.viewState;
      var viewResolution = viewState.resolution;
      var imageSource = this.getLayer().getSource();
      var hints = frameState.viewHints;
      var renderedExtent = frameState.extent;
      if (layerState.extent !== undefined) {
        renderedExtent = getIntersection(renderedExtent, fromUserExtent(layerState.extent, viewState.projection));
      }
      if (!hints[ViewHint.ANIMATING] && !hints[ViewHint.INTERACTING] && !isEmpty(renderedExtent)) {
        if (imageSource) {
          var projection = viewState.projection;
          var image = imageSource.getImage(renderedExtent, viewResolution, pixelRatio, projection);
          if (image) {
            if (this.loadImage(image)) {
              this.image_ = image;
            } else if (image.getState() === ImageState.EMPTY) {
              this.image_ = null;
            }
          }
        } else {
          this.image_ = null;
        }
      }
      return !!this.image_;
    }

    /**
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @return {Uint8ClampedArray} Data at the pixel location.
     */
  }, {
    key: "getData",
    value: function getData(pixel) {
      var frameState = this.frameState;
      if (!frameState) {
        return null;
      }
      var layer = this.getLayer();
      var coordinate = applyTransform(frameState.pixelToCoordinateTransform, pixel.slice());
      var layerExtent = layer.getExtent();
      if (layerExtent) {
        if (!containsCoordinate(layerExtent, coordinate)) {
          return null;
        }
      }
      var imageExtent = this.image_.getExtent();
      var img = this.image_.getImage();
      var imageMapWidth = getWidth(imageExtent);
      var col = Math.floor(img.width * ((coordinate[0] - imageExtent[0]) / imageMapWidth));
      if (col < 0 || col >= img.width) {
        return null;
      }
      var imageMapHeight = getHeight(imageExtent);
      var row = Math.floor(img.height * ((imageExtent[3] - coordinate[1]) / imageMapHeight));
      if (row < 0 || row >= img.height) {
        return null;
      }
      return this.getImageData(img, col, row);
    }

    /**
     * Render the layer.
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */
  }, {
    key: "renderFrame",
    value: function renderFrame(frameState, target) {
      var image = this.image_;
      var imageExtent = image.getExtent();
      var imageResolution = image.getResolution();
      var _ref = Array.isArray(imageResolution) ? imageResolution : [imageResolution, imageResolution],
        _ref2 = _slicedToArray(_ref, 2),
        imageResolutionX = _ref2[0],
        imageResolutionY = _ref2[1];
      var imagePixelRatio = image.getPixelRatio();
      var layerState = frameState.layerStatesArray[frameState.layerIndex];
      var pixelRatio = frameState.pixelRatio;
      var viewState = frameState.viewState;
      var viewCenter = viewState.center;
      var viewResolution = viewState.resolution;
      var scaleX = pixelRatio * imageResolutionX / (viewResolution * imagePixelRatio);
      var scaleY = pixelRatio * imageResolutionY / (viewResolution * imagePixelRatio);
      this.prepareContainer(frameState, target);

      // desired dimensions of the canvas in pixels
      var width = this.context.canvas.width;
      var height = this.context.canvas.height;
      var context = this.getRenderContext(frameState);

      // clipped rendering if layer extent is set
      var clipped = false;
      var render = true;
      if (layerState.extent) {
        var layerExtent = fromUserExtent(layerState.extent, viewState.projection);
        render = intersectsExtent(layerExtent, frameState.extent);
        clipped = render && !containsExtent(layerExtent, frameState.extent);
        if (clipped) {
          this.clipUnrotated(context, frameState, layerExtent);
        }
      }
      var img = image.getImage();
      var transform = composeTransform(this.tempTransform, width / 2, height / 2, scaleX, scaleY, 0, imagePixelRatio * (imageExtent[0] - viewCenter[0]) / imageResolutionX, imagePixelRatio * (viewCenter[1] - imageExtent[3]) / imageResolutionY);
      this.renderedResolution = imageResolutionY * pixelRatio / imagePixelRatio;
      var dw = img.width * transform[0];
      var dh = img.height * transform[3];
      if (!this.getLayer().getSource().getInterpolate()) {
        context.imageSmoothingEnabled = false;
      }
      this.preRender(context, frameState);
      if (render && dw >= 0.5 && dh >= 0.5) {
        var dx = transform[4];
        var dy = transform[5];
        var opacity = layerState.opacity;
        if (opacity !== 1) {
          context.save();
          context.globalAlpha = opacity;
        }
        context.drawImage(img, 0, 0, +img.width, +img.height, dx, dy, dw, dh);
        if (opacity !== 1) {
          context.restore();
        }
      }
      this.postRender(this.context, frameState);
      if (clipped) {
        context.restore();
      }
      context.imageSmoothingEnabled = true;
      return this.container;
    }
  }]);
}(CanvasLayerRenderer);
export default CanvasImageLayerRenderer;